module.exports = "<div id=\"power-gauge\"></div>"